import React, { useEffect, useState } from 'react';
import Chart from 'chart.js/auto';
import Body from '../components/Body';
import {ScatterController} from 'chart.js';

// Configure Contentful Client
const contentful = require('contentful')
const client = contentful.createClient({
  space: process.env.REACT_APP_CSPACE,
  accessToken: process.env.REACT_APP_CTOKEN
})

// TODO: Replace DATA with Contentful Data Arrays

const data = {
  datasets: [
  {
    data: [
      { label: 'Change Networks', x: -3, y: 3, id: '3FQuCJwRYMbTdvhzOVYHS' },
      { label: 'Composable Business Model', x: -1, y: 5, id: '4QYbIFwgHL1fiEG4Iggb6D' },
      { label: 'Crucial Conversations', x: -2, y:7, id: '6ksrteDpK8i4LP5LzghJus' },
      { label: 'Data Mesh', x: -6, y: 2.25, id: '46J9jAj53lHGJJPFkw5UDs' },
      { label: 'Event-Driven Architecture', x: -1.5, y: 4.25, id: '1UAlXhQHiQATrTNOiHBFlw' },
      { label: 'Four Key Metrics', x: -1.25, y: 1.25, id: '1LZj6XdxcoUmhBLVVfLqay' },
      { label: 'Micro Frontends', x: -1, y: 10, id: '3eIeshbTWhscgmIVMKCddI' },
      { label: 'Remote Workshopping', x: -4, y: 1.25, id: '58GwjbvDc6UjWvdDSxdwn' },
      { label: 'Remote Ensemble Programming', x: -7, y: 1.25, id: 'fwYbQLbtxDazbggjps8Vl' },
      { label: 'Site Reliability Engineering', x: -4, y: 3.5, id: '508zTaThURBolWJeTej0x6' },
      { label: 'Team Typologies', x: -1.2, y: 2.3, id: '4B7ZImqRxVyKzFOMW2Z7m0' },
      { label: 'Trunk-Based Development', x: -6, y: 1.25, id: 'rnsmXwnWk8UwIzQ12qPEG' },
      { label: 'Two-in-the-Box Leadership', x: -4.75, y: 5.75, id: '2oqzqONHVH738rT4xIbBAL' },
      { label: 'Extreme Programming (XP)', x: -7.5, y: 2.25, id: '2q61fbCOcvMT7rTQTJq9By' },
    ],
    borderColor: "rgba(0,85,210,0.2)",
    backgroundColor: "#0055D2",
  },
  {
    data: [
      { label: 'Code With Me', x: 3, y: 7, id: '7rKcwUYf1DtU5uPs9AnnDc' },
      { label: 'Github Co-Pilot', x: 6, y: 1.5, id: '78zONwnmpvL3JaZqoBRQyj' },
      { label: 'Dynatrace', x: 2.5, y: 4.25, id: 'dCFikXQNxoTW7Xpg5ch2t' },
      { label: 'Graphana', x: 2.25, y: 1.25, id: '7nu1pd60HvMQcUHOAJ6rS6' },
      { label: 'LaunchDarkly', x: 1.25, y: 1.25, id: '1UgHAsjlwAWAjG06Co7zZY' },
      { label: 'LocalStack', x: 1.25, y: 5, id: '1Ng4i7EO44Fl4iYiYTSbi9' },
      { label: 'Mob', x: 5, y: 5, id: '4hzLKQS9okA8iX61zyFlxy' },
      { label: 'Pendo', x: 1.5, y: 6, id: '6ISoVhCE5XDqevqEEdLZrT' },
      { label: 'SenseMaker', x: 5, y: 7, id: '36UEdc9WHkX6iDqgUbvGde' },
    ],
    borderColor: "rgba(17,125,82,0.2)",
    backgroundColor: "#009459",
  },
  {
    data: [
      { label: 'AWS Serverless Services', x: -2.5, y: -1.5, id: '3QL33WkYPQnw38oPOM3ROq' },
      { label: 'AWS SageMaker', x: -6, y: -1.5, id: '2UxClUYJC7PL7ytMbodV0S' },
      { label: 'AWS Glue', x: -7, y: -1.5, id: '2IJ2ZKyNgiZulvs0m7rQiQ' },
      { label: 'Backstage', x: -1.5, y: -7, id: '2WKDZuPposUlnxaEKKddXS' },
      { label: 'Contentful', x: -3.5, y: -6.5, id: '4XG3YFOnpjLXNBPKO5VxZ5' },
      { label: 'Robotic Process Automation', x: -10, y: -2, id: '3NwPfk23dFqzo5hrUmsIJ5' },
      { label: 'Metaverse', x: -1, y: -10, id: '1oXebvqcFzLsx9tfPbOLHH' },
    ],
    borderColor: "rgba(0,0,0,0.2)",
    backgroundColor: "black",
  },
  {
    data: [
      { label: 'React Hooks', x: 1.5,  y: -1.25, id: '7nnYe7BpWtqWFn0oUs7kaq' },
      { label: 'Gatsby.js', x: 1.5, y: -4.25, id: '4i7ofRSDnGAWpCFgnEWWzp' },
      { label: 'React Query', x: 5, y: -5, id: '1JyXIoqnnvkTllnyA3UuHe' },
      { label: 'TypeScript', x: 4.5, y: -1.25, id: '1M9tB4oasYrNNufmnhi1vy' },
      { label: 'Rust', x: 10, y: -1, id: '6i6IhCk5HL0Osn5DnrdkUF' },
    ],
    borderColor: "rgba(174,28,0,0.2)",
    backgroundColor: "#AE1C00",
  }]
};


// TODO: Data
const QuadChart=()=>
{
  const [contentfulData, setContentfulData] = useState(null);
  const [ entryId, setEntryId ] = useState(null);
  const titleTooltip = (e) => { return e[0].raw.label }
  const labelTooltip = (e) => { return '' }
  function handleClick(e){ setEntryId(e.chart.tooltip.dataPoints[0].raw.id); };
  const config = {
    type: "scatter",
    data: data,
    options: {
      scales: {
        label: {
           display: false
        },
        y: {
          display: false,
          grid: {
            display: false,
          },
        },
        x: {
          display: false,
          grid: {
            display: false,
          },
        },
      },
      onClick: (e) => {
        handleClick(e)
      },
      aspectRatio: 1,
      responsive: true,
      elements : {
        point: {
          pointStyle: 'circle',
          radius: 8,
          hitRadius: 2,
          hoverRadius: 10,
          hoverBorderWidth: 10,
          borderWidth: 20
        },
      },
      plugins: {
        tooltip: {
          enabled: true,
          titleMarginBottom: 0,
          footerMarginTop: 0,
          xPadding: 50,
          padding: 10,
          callbacks: {
            title: titleTooltip,
            label:labelTooltip
          }
        },
        legend: {
          display: false
        }
      }
    }
  };

  useEffect(() => {
    const ctx = document.getElementById('myChart');
    var myChart = new Chart(ctx, config);
  });

  const MyCanvasStuff = React.memo( function CanvasStuff() {
    // console.log(contentfulData);
    return (
      <div className="col-lg-7">
        <canvas id="myChart" className="shadow-lg"/>
      </div>
  )})

  return (
    <>
      <div className="row my-5 justify-content-md-center">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <div className="" id="navbarNavAltMarkup">
              <div className="navbar-nav">
                <a className="btn btn-primary" data-bs-toggle="collapse" data-bs-target="#glossary" aria-expanded="false" aria-controls="glossary" >Glossary</a>
              </div>

            </div>
            <span className="navbar-text">
              Hover and Click on Radar Elements below
            </span>
          </div>
        </nav>

        <div className="collapse bg-dark row" id="glossary">
          <div className="py-5 col-3 text-light">
            <h6>Techniques</h6>
            <ul>
              <li><a href="#" onClick={() => setEntryId("3FQuCJwRYMbTdvhzOVYHS")}>Change Networks</a></li>
              <li><a href="#" onClick={() => setEntryId("4QYbIFwgHL1fiEG4Iggb6D")}>Composable Business Models</a></li>
              <li><a href="#" onClick={() => setEntryId("6ksrteDpK8i4LP5LzghJus")}>Crucial Conversations</a></li>
              <li><a href="#" onClick={() => setEntryId("46J9jAj53lHGJJPFkw5UDs")}>Data Mesh</a></li>
              <li><a href="#" onClick={() => setEntryId("1UAlXhQHiQATrTNOiHBFlw")}>Event-Driven Architectures</a></li>
              <li><a href="#" onClick={() => setEntryId("1LZj6XdxcoUmhBLVVfLqay")}>Four Key Metrics</a></li>
              <li><a href="#" onClick={() => setEntryId("3eIeshbTWhscgmIVMKCddI")}>Micro Frontends</a></li>
              <li><a href="#" onClick={() => setEntryId("fwYbQLbtxDazbggjps8Vl")}>Remote Ensemble Programming</a></li>
              <li><a href="#" onClick={() => setEntryId("58GwjbvDc6UjWvdDSxdwn")}>Remote Workshopping</a></li>
              <li><a href="#" onClick={() => setEntryId("508zTaThURBolWJeTej0x6")}>Site Reliability Engineering</a></li>
              <li><a href="#" onClick={() => setEntryId("4B7ZImqRxVyKzFOMW2Z7m0")}>Team Topologies</a></li>
              <li><a href="#" onClick={() => setEntryId("rnsmXwnWk8UwIzQ12qPEG")}>Trunk-Based Development</a></li>
              <li><a href="#" onClick={() => setEntryId("2oqzqONHVH738rT4xIbBAL")}>Two-in-the-Box Leadership</a></li>
              <li><a href="#" onClick={() => setEntryId("2q61fbCOcvMT7rTQTJq9By")}>Extreme Programming (XP)</a></li>
            </ul>
          </div>
          <div className="py-5 col-3 text-light">
            <h6>Tools</h6>
            <ul>
              <li><a href="#" onClick={() => setEntryId("7rKcwUYf1DtU5uPs9AnnDc")}>Code With Me</a></li>
              <li><a href="#" onClick={() => setEntryId("dCFikXQNxoTW7Xpg5ch2t")}>Dynatrace</a></li>
              <li><a href="#" onClick={() => setEntryId("78zONwnmpvL3JaZqoBRQyj")}>Github Copilot</a></li>
              <li><a href="#" onClick={() => setEntryId("7nu1pd60HvMQcUHOAJ6rS6")}>Graphana</a></li>
              <li><a href="#" onClick={() => setEntryId("1UgHAsjlwAWAjG06Co7zZY")}>LaunchDarkly</a></li>
              <li><a href="#" onClick={() => setEntryId("1Ng4i7EO44Fl4iYiYTSbi9")}>LocalStack</a></li>
              <li><a href="#" onClick={() => setEntryId("4hzLKQS9okA8iX61zyFlxy")}>Mob</a></li>
              <li><a href="#" onClick={() => setEntryId("6ISoVhCE5XDqevqEEdLZrT")}>Pendo</a></li>
              <li><a href="#" onClick={() => setEntryId("36UEdc9WHkX6iDqgUbvGde")}>SenseMaker</a></li>
            </ul>
          </div>
          <div className="py-5 col-3 text-light">
            <h6>Platforms</h6>
            <ul>
              <li><a href="#" onClick={() => setEntryId("2IJ2ZKyNgiZulvs0m7rQiQ")}>AWS Glue Low-Code ETL</a></li>
              <li><a href="#" onClick={() => setEntryId("3QL33WkYPQnw38oPOM3ROq")}>AWS Serverless Services</a></li>
              <li><a href="#" onClick={() => setEntryId("2UxClUYJC7PL7ytMbodV0S")}>AWS SageMaker</a></li>
              <li><a href="#" onClick={() => setEntryId("2WKDZuPposUlnxaEKKddXS")}>Backstage</a></li>
              <li><a href="#" onClick={() => setEntryId("4XG3YFOnpjLXNBPKO5VxZ5")}>Contentful</a></li>
              <li><a href="#" onClick={() => setEntryId("1oXebvqcFzLsx9tfPbOLHH")}>Metaverse</a></li>
              <li><a href="#" onClick={() => setEntryId("3NwPfk23dFqzo5hrUmsIJ5")}>Robotic Process Automation (RPA)</a></li>
            </ul>
          </div>
          <div className="py-5 col-3 text-light">
            <h6>Languages & Frameworks</h6>
            <ul>
              <li><a href="#" onClick={() => setEntryId("7nnYe7BpWtqWFn0oUs7kaq")}>React Hooks</a></li>
              <li><a href="#" onClick={() => setEntryId("4i7ofRSDnGAWpCFgnEWWzp")}>Gatsby.js</a></li>
              <li><a href="#" onClick={() => setEntryId("1JyXIoqnnvkTllnyA3UuHe")}>React Query</a></li>
              <li><a href="#" onClick={() => setEntryId("1M9tB4oasYrNNufmnhi1vy")}>TypeScript</a></li>
              <li><a href="#" onClick={() => setEntryId("6i6IhCk5HL0Osn5DnrdkUF")}>Rust</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row justify-content-md-center my-5">
        <div className="col-lg-5">
          <Body entryId = { entryId } />
        </div>
        <MyCanvasStuff />
      </div>
    </>
  )
}

export default QuadChart
